import { render, staticRenderFns } from "./PortineriaOspitiIdView.vue?vue&type=template&id=59652eae&"
import script from "./PortineriaOspitiIdView.vue?vue&type=script&lang=ts&"
export * from "./PortineriaOspitiIdView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports